<template>
  <router-link :to="backTo" class="flex items-center">
    <BaseIcon name="arrow-left" />
    {{ label }}
  </router-link>
</template>

<script>
import { determineRouteWithQuery } from "@/router";

const LABELS = {
  contacts: "Dossiers",
  "pre-deals": "Pre-Deals",
  deals: "Deals",
  reminders: "Reminders",
  people: "Personen"
};

export default {
  computed: {
    label() {
      let name = this.$store.state.lastListRoute.replace(".mine");

      return LABELS[name] ? `Terug naar ${LABELS[name]}` : "Terug";
    },

    backTo() {
      let name = this.$store.state.lastListRoute;

      if (!name) return { name: "contacts" };

      return determineRouteWithQuery(name);
    }
  }
};
</script>